'use client'

import { forwardRef } from 'react'

import { Input, InputProps } from '@/components/ui/input'
import { cn } from '@/lib/utils'

interface Props extends InputProps {
  example?: string
  error?: string
  containerClassName?: string
}

const InputWithExample = forwardRef<HTMLInputElement, Props>(
  ({ example, error, containerClassName, ...props }, ref) => {
    return (
      <div
        className={cn([
          'group bg-foreground/5 relative mb-2 flex items-center justify-between transition-colors group-focus:border group-focus:border-white/20',
          error && 'border-destructive/40 border',
          containerClassName,
        ])}
      >
        <Input
          className="w-full"
          inputClassName="bg-transparent"
          placeholder={example}
          {...props}
          ref={ref}
        />
        {error && (
          <p className="text-red absolute top-full left-1/2 mt-2 -translate-x-1/2 text-sm">
            {error}
          </p>
        )}
      </div>
    )
  }
)

InputWithExample.displayName = 'InputWithExample'

export default InputWithExample
